import {
    Card,
    FormH4,
    TextWrapper,
    TopLine
} from './AgenticElements';

const SlateCard = ({ slate }) => {

    return (
        <>
            <Card>
                {/* <ImgWrap>
                    <Img src={app.img} alt={app.alt} />
                </ImgWrap> */}
                <TextWrapper>
                    <TopLine>{slate.Operator}</TopLine>
                    <TopLine>{slate.OperatorName}</TopLine>
                    <FormH4>{slate.OperatorStartTime}</FormH4>
                    <FormH4>Games: {slate.NumberOfGames}</FormH4>
                    <FormH4 errorText={slate.RemovedByOperator == true}>{slate.RemovedByOperator ? ("Removed") : ""}</FormH4>
                    {/* <BtnWrap>
                            <BtnLink
                                offset={-80}
                                primary={true}
                                dark={false}
                                dark2={false}
                            >
                                Add
                            </BtnLink>
                        </BtnWrap> */}
                </TextWrapper>
            </Card>
        </>
    );
};

export default SlateCard;
